"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringSource = void 0;
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class StringSource extends core_1.Node {
    constructor() {
        super();
        this.process = () => this.setOutputs(0, this.state.value);
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "value", dataType: "string" }]);
    }
    created(options) {
        const { width = 160, name = "String Source", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    setupUI() {
        this.input = this.createUI("core/input", {
            value: "",
            propName: "value",
            input: true,
            output: true,
            height: 20,
            style: { type: ui_1.InputType.Text, grow: 0.7 },
        });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Value", style: { grow: 0.3 } }), this.input],
            style: { spacing: 10 },
        }));
    }
    setupListeners() {
        this.watch("value", () => this.process());
    }
}
exports.StringSource = StringSource;
StringSource.DefaultState = { value: "" };
